import { Saga } from 'redux-saga'
import { all } from 'redux-saga/effects'
import { sessionSaga } from '.'

export function combineSessionSaga(saga: Saga) {
  return function* () {
    yield all([saga ? saga() : undefined, sessionSaga()])
  }
}
